import { CalculationHistoryTableFilters, CaregiverTableFilter, FamilyTableFilter } from "../types/filters";

export const DEFAULT_FAMILY_TABLE_FILTER: FamilyTableFilter = {
  name: null,
  surname: null,
  age: null,
  withCaregiver: false,
  noCaregiver: false,
  coverage: null,
};

export const DEFAULT_CAREGIVER_TABLE_FILTER: CaregiverTableFilter = {
  name: null,
  surname: null,
  age: null,
  engaged: false,
  notEngaged: false,
  coverage: null,
};

export const DEFAULT_CALCULATION_HISTORY_TABLE_FILTERS: CalculationHistoryTableFilters = {
  caregiver: null,
  family: null,
  from: null,
  result: null,
  to: null,
}